import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-no-data-found',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, TranslocoModule],
    templateUrl: './no-data-found.component.html',
    styleUrls: ['./no-data-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataFoundComponent {
    /** Plain text title (bypasses i18n). */
    @Input() title: string | null = null;
    /** Transloco key when `title` is not set. */
    @Input() titleKey = 'No data found';
    @Input() message: string | null = null;
    @Input() messageKey: string | null = null;
    @Input() icon = 'heroicons_outline:inbox';
    /**
     * Flat layout: no dashed card, transparent background (e.g. nested inside another container).
     * Default matches the project analytics “no data” block (dashed card + primary icon).
     */
    @Input() compact = false;

     @Input() actionLabel: string | null = null;
     @Input() actionLabelKey: string | null = null;
     @Input() actionIcon: string | null = null;
     @Output() actionClick = new EventEmitter<void>();

    get hasAction(): boolean {
        return !!(this.actionLabel || this.actionLabelKey);
    }

    onActionClick(): void {
        this.actionClick.emit();
    }
}
